import React, { useState,useEffect } from "react";
import "./ConfigurarReceta.css";
import ConfigurableField from "./ConfigurableField";
import PreviewReceta from "./PreviewReceta"; 
import { obtenerConfiguracionReceta, guardarConfiguracionReceta } from "../../../../services/recetas"; 
import UploadImagenConfig from "./UploadImagenConfig";
import WhatsappAyudaReceta from "./WhatsappAyudaReceta";
import { initialConfig, camposConfigurables } from "../../Recetas electronicas/RecetaConfig";
import TextosLibresConfig from "./TextosLibresConfig";

       const ConfigurarReceta = () => {  
        const [config, setConfig] = useState(initialConfig);
        const [isLoading, setIsLoading] = useState(false);
        const [error, setError] = useState(null);
        const [guardadoExitoso, setGuardadoExitoso] = useState(false);
        const [mostrarWhatsappPorConfigPrevia, setMostrarWhatsappPorConfigPrevia] = useState(false);
        const [busquedaCampo, setBusquedaCampo] = useState("");
      
        useEffect(() => {
          const cargarConfiguracion = async () => {
            try {
             
              const configGuardada = await obtenerConfiguracionReceta();
              
              if (configGuardada) {
                
                
                // Verificar si la configuración está anidada o es directa
                const configData = configGuardada.configuracion || configGuardada;

                // Si la API ya trae una configuración guardada real,
                // mostramos ayuda porque probablemente volvió a configurarla.
                const esConfigPreviaReal =
                  configData &&
                  Object.keys(configData).length > 0 &&
                  JSON.stringify(configData) !== JSON.stringify(initialConfig);

                if (esConfigPreviaReal) {
                  setMostrarWhatsappPorConfigPrevia(true);
                }

                
                // Aplicar la configuración al estado
                setConfig(prevConfig => ({
                  ...prevConfig,           // Mantén los valores default
                  ...configData,           // Sobreescribe con valores guardados
                  // Asegura valores críticos o calcula valores derivados si es necesario
                  zoom: configData.zoom || prevConfig.zoom || 0.5
                }));
                
                
              } else {
                
              }
            } catch (error) {
              console.error("Error cargando la configuración:", error);
            }
          };
          
          cargarConfiguracion();
        }, []);
  
  const handleSizeChange = (e) => {
  const tamaño = e.target.value;
    let ancho, alto;

    switch (tamaño) {
      case "Media carta": 
      ancho = 21.59;
      alto = 14;
      break;
      case "Carta":
        ancho= 21.59;
        alto= 27.94;
        break;    
      
      case "personalizado":
        ancho = config.anchoPersonalizado;
        alto = config.altoPersonalizado;
        break;
      default:
        // Carta por defecto
        ancho = 21.59;
        alto = 14;
        break;
    }

    setConfig((prev) => ({
      ...prev,
      tamañoHoja: tamaño,
      anchoPersonalizado: ancho,
      altoPersonalizado: alto,
    }));
  };

  const handleCustomSizeChange = (e) => {
    const { name, value } = e.target;
    setConfig((prev) => ({
      ...prev,
      [name]: parseFloat(value),
    }));
  };

  const handleReset = () => {
    setConfig(initialConfig);
  };

  const handleSave = async () => {
    try {
      // Mostrar un indicador de carga
    
      
      // Guardar la configuración (sin pasar el ID del médico)
      const resultado = await guardarConfiguracionReceta(config);
      
      if (resultado) {
        setGuardadoExitoso(true);
        setMostrarWhatsappPorConfigPrevia(false);
        alert("Configuración guardada correctamente.");
      } else {
        console.error("No se pudo guardar la configuración. Respuesta vacía del servidor.");
        alert("Error al guardar la configuración. Por favor, revisa la consola para más detalles.");
      }
    } catch (error) {
      console.error("Error guardando la configuración:", error);
      let mensajeError = "Error al guardar la configuración.";
      
      // Mostrar detalles del error si están disponibles
      if (error.response && error.response.data) {
        mensajeError += " Detalle: " + JSON.stringify(error.response.data);
      }
      
      alert(mensajeError);
    }
  };

  const normalizarTexto = (texto = "") =>
  texto
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const camposFiltrados = camposConfigurables.filter((campo) =>
  normalizarTexto(campo.label).includes(
    normalizarTexto(busquedaCampo.trim())
  )
);  

  return (
    <div className="configurar-receta-layout">
      <h2>Configurar Receta Electrónica</h2>
      <WhatsappAyudaReceta
        mostrarPorConfigPrevia={mostrarWhatsappPorConfigPrevia}
        guardadoExitoso={guardadoExitoso}
      />

      <div className="configuracion-contenido">
        {/* Sección de configuración */}
        <div className="formulario-configuracion">
          {/* Sección de campos */}
          {/* Sección de tamaño de hoja */}
          <div className="seccion-tamaño-hoja">
            <h3>Tamaño de la Hoja</h3>
            <select value={config.tamañoHoja} onChange={handleSizeChange}>
              <option value="Media Carta">Media Carta (21.59 x 14 cm)</option>
              <option value="Carta">Carta (21.59 x 27.94 cm)</option>
              <option value="personalizado">Personalizado</option>
            </select>
            {config.tamañoHoja === "personalizado" && (
              <div className="tamaño-personalizado">
                <label>
                  Ancho (cm):
                  <input
                    type="number"
                    name="anchoPersonalizado"
                    value={config.anchoPersonalizado}
                    onChange={handleCustomSizeChange}
                  />
                </label>
                <label>
                  Alto (cm):
                  <input
                    type="number"
                    name="altoPersonalizado"
                    value={config.altoPersonalizado}
                    onChange={handleCustomSizeChange}
                  />
                </label>
              </div>
            )}
          </div>      
          <div className="seccion-imagenes-personalizadas">
            <h3>Imágenes Personalizadas</h3>

            <UploadImagenConfig
              label="Imagen Encabezado / Marca de Agua"
              urlActual={config.urlImagenPersonalizada}
              tipo="encabezado"
              setConfig={setConfig}
            />

           {/* <UploadImagenConfig
              label="Firma Electrónica"
              urlActual={config.urlFirmaPersonalizada}
              tipo="firma"
              setConfig={setConfig}
            />*/}
          </div>
          <div className="seccion-campos">
            <h3>Campos a mostrar</h3>

            <div className="buscador-campos-receta">
           <input
              type="text"
              placeholder="Buscar campo a configurar"
              className="search-bar-receta"
              value={busquedaCampo}
              onChange={(e) => setBusquedaCampo(e.target.value)}
            />
            </div>

            {camposFiltrados.length > 0 ? (
              camposFiltrados.map((campo, index) => (
                <div key={campo.fieldKey || index} className="config-nombre">
                  <ConfigurableField
                    label={campo.label}
                    config={config}
                    setConfig={setConfig}
                    fieldKey={campo.fieldKey}
                    labelKey={campo.labelKey}
                    marginXKey={campo.marginXKey}
                    marginYKey={campo.marginYKey}
                    sizeHorizontalKey={campo.sizeHorizontalKey}
                    sizeVerticalKey={campo.sizeVerticalKey}
                    sizeKey={campo.sizeKey}
                    fontKey={campo.fontKey}
                    colorKey={campo.colorKey}
                    boldKey={campo.boldKey}
                    tipo={campo.tipo}
                  />
                </div>
              ))
            ) : (
              <div className="sin-resultados-campos">
                No se encontraron campos.
              </div>
            )}
          </div>
          <TextosLibresConfig
            config={config}
            setConfig={setConfig}
          />

          {/* Botones */}
          <div className="botones-configuracion">
            <button onClick={handleSave}>Guardar Cambios</button>
            <button onClick={handleReset}>Resetear a Configuración por Defecto</button>
          </div>
        </div>

        <PreviewReceta 
          config={config} 
          camposConfigurables={camposConfigurables} 
          setConfig={setConfig}
        />
      </div>
    </div>
  );
};

export default ConfigurarReceta;
